(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('common', common);

    common.$inject = ['$location', '$q', '$rootScope', '$timeout', 'config', 'userService', 'logger', 'notifier', 'opsIncludeVersion'];

    /* @ngInject */
    function common($location, $q, $rootScope, $timeout, config, userService, logger, notifier, opsIncludeVersion) {
        var throttles = {};
        var mainState = { mainDate: new Date() };
       
        var service = {
            // common angular dependencies
            $location: $location,
            $q: $q,
            $timeout: $timeout,
            // common 
            userService: userService,
            logger: logger, // for accessibility
            notifier: notifier,
            config: config,
            // generic
            createSearchThrottle: createSearchThrottle,
            debouncedThrottle: debouncedThrottle,
            isNumber: isNumber,
           
            textContains: textContains,
            setAuditInfo: setAuditInfo,
            setMainState: setMainState,
            getMainState: getMainState,
            convertDateStringsToDates: convertDateStringsToDates,
            convertUtcKeysToLocal: convertUtcKeysToLocal,
            buildDateTime: buildDateTime,
            opsIncludeVersion: opsIncludeVersion,
            checkIsAdmin: checkIfAdmin
        };

        return service;
        

        function checkIfAdmin() {
            userService.checkIsAdmin().then(function (d) {
                if (!d) {
                    userService.logout();
                    $location.path('/404')
                }
                
        }) ;

        }

        function setMainState (key, value) {
            mainState[key] = value;
        }
        function getMainState(key) {
            return mainState[key];
        }

        function createSearchThrottle(viewmodel, list, filteredList, filter, delay) {
            // After a delay, search a viewmodel's list using
            // a filter function, and return a filteredList.
            
            // custom delay or use default
            delay = +delay || 300;
            // if only vm and list parameters were passed, set others by naming convention
            if (!filteredList) {
                // assuming list is named sessions, filteredList is filteredSessions
                //filteredList = 'filtered' + list[0].toUpperCase() + list.substr(1).toLowerCase(); // string
                filteredList = 'filtered' + list[0].toUpperCase() + list.substr(1); 
                // filter function is named sessionFilter
                filter = list + 'Filter'; // function in string form
            }

            // create the filtering function we will call from here
            var filterFn = function () {
                var clone = structuredClone(viewmodel[list]);
                // translates to ...
                // vm.filteredSessions
                //      = vm.sessions.filter(function(item( { returns vm.sessionFilter (item) } );
                viewmodel[filteredList] = clone.filter(function (item) {
                    return viewmodel[filter](item);
                });
            };
            
            return (function () {
                // Wrapped in outer IIFE so we can use closure
                // over filterInputTimeout which references the timeout
                var filterInputTimeout;

                // return what becomes the 'applyFilter' function in the controller
                return function (searchNow) {
                    if (filterInputTimeout) {
                        $timeout.cancel(filterInputTimeout);
                        filterInputTimeout = null;
                    }
                    if (searchNow || !delay) {
                        filterFn();
                    } else {
                        filterInputTimeout = $timeout(filterFn, delay);
                    }
                };
            })();
        }

        function debouncedThrottle(key, callback, delay, immediate) {
            // Perform some action (callback) after a delay.
            // Track the callback by key, so if the same callback
            // is issued again, restart the delay.

            var defaultDelay = 1000;
            delay = delay || defaultDelay;
            if (throttles[key]) {
                $timeout.cancel(throttles[key]);
                throttles[key] = undefined;
            }
            if (immediate) {
                callback();
            } else {
                throttles[key] = $timeout(callback, delay);
            }
        }

        function isNumber(val) {
            // negative or positive
            return (/^[-]?\d+$/).test(val);
        }

        function textContains(text, searchText) {
            return text && -1 !== text.toLowerCase().indexOf(searchText.toLowerCase());
        }

        function convertDateStringsToDates(input) {
            var regexIso8601 = /^^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
            // Ignore things that aren't objects.
            if (typeof input !== "object") return input;

            for (var key in input) {
                if (!input.hasOwnProperty(key)) continue;

                var lowerKey = key.toLowerCase();
                if (lowerKey === "id") continue;
                try {
                    if (lowerKey.endsWith("id")) continue;
                }
                catch (badProp) {
                    console.log(badProp);
                }
                

                var value = input[key];
                
                var match;

                if (typeof value === "string" && (match = value.match(regexIso8601))) {
                    var milliseconds = Date.parse(match[0]);
                    if (!isNaN(milliseconds)) {
                        input[key] = new Date(milliseconds);
                    }
                } else if (typeof value === "object") {
                    convertDateStringsToDates(value);
                }
            }
        }
        function convertUtcKeysToLocal(input) {
            var regexIso8601 = /^^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
            // Ignore things that aren't objects.
            if (typeof input !== "object") return input;

            for (var key in input) {
                if (!input.hasOwnProperty(key)) continue;

                var value = input[key];
                var match;
                if (typeof value === "string" && key.indexOf('Utc') > 0 && (match = value.match(regexIso8601))) {
                    var utc = moment.utc(match[0]);
                    input[key] = utc.toDate();
                    
                } else if (typeof value === "object") {
                    convertUtcKeysToLocal(value);
                }
            }
        }


        function buildDateTime(date, time) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), 0, 0);
        }

        function setAuditInfo(vm) {
            if (vm["DateAddedUtc"] && vm["DateAddedUtc"] != "0001-01-01T00:00:00") {
                vm["DateAdded"] = moment(moment.utc(vm["DateAddedUtc"]).toDate()).toDate();
            }
            else {
                vm["DateAdded"] = moment().toDate();
                vm["AddedBy"] = userService.userName();
            }

            if (vm["DateChangedUtc"] && vm["DateChangedUtc"] != "0001-01-01T00:00:00") {
                vm["DateChanged"] = moment(moment.utc(vm["DateChangedUtc"]).toDate()).toDate();
            }
            else {
                vm["DateChanged"] = moment().toDate();
                vm["ChangedBy"] = userService.userName();
            }
        }

    }
})();